import { Result } from "antd";

/** /config.json が読めないときだけ出る画面(API が落ちている等)。 */
export function StartupError({ message }: { message: string }) {
  return (
    <Result
      status="error"
      title="設定を読み込めなかった"
      subTitle={`API の /config.json に到達できない: ${message}`}
    />
  );
}
